import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { Box, TextField, Button, Grid, Autocomplete, Select, MenuItem, InputLabel, FormControl, Radio, FormControlLabel, FormLabel, RadioGroup,
} from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import { useSnackbar } from 'notistack';
import AddIcon from '@mui/icons-material/Add';
import { saveIncentive } from 'services/incentives';
import { AppContext } from 'core/context/';
import { getPropertiesByOwner } from 'services/libraries';

const AddIncentive = ({ pageFilters, onSuccess, onFailure }) => {

  const [libraries, setLibraries] = useState([]);

  const defaultFormFields = useMemo(() => ({
    propertyId: '',
    userId: '',
    description: '',
    amount: '',
    target: 'Wallet'
  }),[]);

 
  const { enqueueSnackbar } = useSnackbar();
  const { vendors } = useContext(AppContext);
  const { handleSubmit, control, formState: { errors }, reset, watch } = useForm({
    mode: 'onTouched',
    defaultValues: {...defaultFormFields}
  });

  // useEffect(() => {
  //   if(pageFilters?.library?.libraryId){
  //     setValue('propertyId', pageFilters.library)
  //   }

  //   if(pageFilters?.vendor?.userId){
  //     setValue('userId', pageFilters.vendor )
  //   }
   
  // }, [pageFilters, setValue]);

  const getVendorLibraries = useCallback((ownerId) => {
    getPropertiesByOwner({ownerId}).then(({response, error}) => {
      if(response){
        setLibraries([...(response || [])]);
      } else {
        setLibraries([]);
      }
    });
  },[]);
  
  const userId = watch('userId');
  useEffect(() => {
    if(userId){
      getVendorLibraries(userId.userId);
    }else{
      setLibraries([]);
    }
  }, [userId, getVendorLibraries])
  
  

  const resetForm = () => {
    reset({...defaultFormFields});
  };

  const onSubmit = (data) => {
    saveUserDetails(data);
  }

  const saveUserDetails = (data) => {
    const postData ={
      propertyId: data.propertyId.id,
      userId: data.userId.userId,
      description: data.description,
      target: data.target,
      amount: parseFloat(Number(data.amount)).toFixed(2)
      // amount: Number(data.amount)
    };
    saveIncentive({
      ...postData,
    }).then(({response, error}) => {
      if(response){
        enqueueSnackbar((`Incentive added successfully`), {variant: 'success'});
        resetForm();
        onSuccess()
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
        onFailure()
      }
    });
  }

  const filterOptions = useCallback((options, { inputValue }) => {
    if(inputValue){
      return options.filter((option) => option?.displayName?.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase()) || option?.mobile?.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase()));
    }
    return options;
  }, []);

  return (
    <Box noValidate component="form"  onSubmit={handleSubmit(onSubmit)} sx={{ mt: 2 }} >
      <Grid container columnSpacing={2} rowSpacing={2} justifyContent="center">

        <Grid  item xs={12} sm={11} md={10} lg={10} sx={{mt: 2}}>
          <Controller
            control={control}
            name="userId"
            id="userId"
            rules={{ required: "Select Vendor" }}
            render={({field}) => (
              <Autocomplete
                {...field}
                options={vendors}
                size="small"
                name="userId"
                fullWidth
                filterOptions={filterOptions} 
                getOptionLabel={(option) => option?.displayName || option }
                isOptionEqualToValue={(option, value) => (option?.userId === value?.userId)}
                onChange={(event, newValue) => {
                  field.onChange(newValue);
                }}
                renderOption={(props, option) => <li {...props} key={option.userId}>{option.displayName}</li>}
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    {...field} 
                    error={!!errors?.userId}  
                    required 
                    fullWidth
                    label="Vendor"
                    InputProps={{
                      ...field,
                      ...params.InputProps,
                      // startAdornment: 
                      //   <InputAdornment position="start">
                      //     <IconButton
                      //       aria-label="Vendor Name"
                      //       edge="end"
                      //     >
                      //       <PersonIcon />
                      //     </IconButton>
                      //   </InputAdornment>
                    }}
                  />
                )}
              />
            )}
            onChange={([, data]) => data}
          />
        </Grid>

        <Grid  item xs={12} sm={11} md={10} lg={10}>
          <Controller
            control={control}
            name="propertyId"
            id="propertyId"
            rules={{ required: "Select property" }}
            render={({field}) => (
              <FormControl {...field} required fullWidth error={!!errors?.propertyId}>
                <InputLabel id="property-input-label" size="small">Property</InputLabel>
                <Select
                  // labelId="property-label"
                  // id="property-select-id"
                  label="Property"
                  name="propertyId"
                  required
                  size="small"
                  value={field?.value?.name}
                  onChange={field.onChange}
                >
                   {libraries.map((library, index) => <MenuItem key={index} value={library}>{library.name}</MenuItem>)}
                </Select>
              </FormControl>
            )}
          />
        </Grid>

        <Grid item xs={12} sm={11} md={10} lg={10}>
          <Controller
            control={control}
            name="description"
            id="description"
            rules={{ required: "Enter description"}}
          render={({field}) => (
              <TextField
                {...field}
                margin="normal"
                label="Description"
                required
                error={!!errors?.description}
                size="small"
                fullWidth
                multiline
                minRows={5}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={11} md={10} lg={10}>
            <FormControl error={!!errors?.target} >
              <FormLabel id="target-type-group-label">Transfer to *</FormLabel>
              <Controller
                control={control}
                name="target"
                id="target"
                required
                rules={{ required: "Select transfer target" }}
                defaultValue={"Wallet"}
                render={({field}) => (
                  <RadioGroup
                    {...field}
                    row
                    aria-labelledby="target-type-group-label"
                    name="target"
                    // defaultValue={field?.value}
                  >
                    <FormControlLabel value="Wallet" control={<Radio />} label="Wallet" />
                    <FormControlLabel value="Bank Account" control={<Radio />} label="Bank Account" />
                  </RadioGroup>
                )}
              />
            </FormControl>
          </Grid> 

        <Grid item xs={12} sm={11} md={10} lg={10}>
          <Controller
            control={control}
            name="amount"
            id="amount"
            rules={{ required: "Enter amount",
              pattern: {value: /^[1-9]\d*(\d+)?$/i,message: 'Please valid amount'},
            }}
          render={({field}) => (
              <TextField
                {...field}
                margin="normal"
                label="Amount"
                required
                error={!!errors?.amount}
                size="small"
                fullWidth
                type="string"
              />
            )}
          />
        </Grid>
          
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Button
            type="submit"
            variant="contained"
            sx={{ mt: 3, mb: 2, textTransform: 'inherit' }}
            startIcon={<AddIcon />}
            color="primary"
          >
            Add
          </Button>
        </Grid>


        </Grid>
    </Box>
  );
}
 
export default React.memo(AddIncentive);
